import React from "react";
import Icon from "../../../components/AppIcon";
import Image from "../../../components/AppImage";

const CivilView = ({ customer, civilWork }) => {
  const getStatus = () => {
    if (customer?.status === "civil_complete") {
      return { label: "Complete", color: "bg-success/10 text-success" };
    }
    if (customer?.status === "civil_inprogress") {
      return { label: "In Progress", color: "bg-warning/10 text-warning" };
    }
    if (customer?.status === "civil_pending") {
      return {
        label: "Pending",
        color:
          "bg-yellow-100 text-yellow-700 dark:bg-yellow-900/30 dark:text-yellow-400",
      };
    }
    return { label: "Not Started", color: "bg-muted text-muted-foreground" };
  };

  const status = getStatus();

  const photos = civilWork?.photos || {};
  const mountingPhoto = photos?.mounting_structure || null;

  return (
    <div>
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
          <Icon name="HardHat" size={20} className="text-primary" />
        </div>
        <h2 className="text-xl md:text-2xl font-semibold text-foreground">
          Civil Work Phase
        </h2>
        <span
          className={`ml-auto inline-flex items-center px-3 py-1 rounded-full text-sm font-medium ${status.color}`}
        >
          {status.label}
        </span>
      </div>

      <div className="space-y-6">
        <div>
          <h3 className="text-base font-semibold text-foreground mb-4">
            Mounting Structure Photo
          </h3>
          <div className="p-4 rounded-lg border border-border bg-muted/30">
            {mountingPhoto ? (
              <div className="aspect-[4/3] rounded-lg overflow-hidden bg-muted">
                <Image
                  src={mountingPhoto}
                  alt="Mounting Structure"
                  className="w-full h-full object-contain bg-muted"
                />
              </div>
            ) : (
              <div className="aspect-[4/3] rounded-lg bg-muted flex items-center justify-center border-2 border-dashed border-border">
                <div className="text-center">
                  <Icon
                    name="Image"
                    size={32}
                    className="mx-auto mb-2 text-muted-foreground"
                  />
                  <p className="text-sm font-medium text-foreground">
                    Mounting Structure
                  </p>
                  <p className="text-xs text-muted-foreground mt-1">
                    Complete structure view
                  </p>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CivilView;
